import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import TransferRoute from "../types/TransferRoute";

type Output = TransferRoute[];

export default function useTransferRouteByLocationsAndCity (
    fromId?: number,
    toId?: number,
    cityId?: number,
    options?: CacheQueryOpts
): CacheQueryOutput<Output> {
    const client = useAPIClient();
    return useCacheQuery<Output>(
        ["transfer_routes", fromId, toId, cityId],
        () => {
            return client.get<any>(`transfer_routes`, {
                origin: fromId,
                destination: toId,
                city: cityId,
            });
        },
        options
    );
}
